import styled from "@emotion/styled";

export const CustomersPage = styled.main`
  margin: 80px 0 140px;
  .text {
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;
    color: #808285;
    margin-bottom: 50px;
  }
  .formWrapper {
    margin: 50px 0 0 0;
    position: relative;
    .title {
      font-weight: 500;
      font-size: 20px;
      line-height: 35px;
      color: #000000;
      margin-bottom: 50px;
    }
  }

  button {
    padding: 9px 45px;
    border-radius: 74px;
  }

  .MuiInputBase-root {
    margin-bottom: 30px;
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {},
  })}
`;

export const ProductBox = styled.div`
  background: url(${props => props.bg}) no-repeat center center / cover, #ffffff;
  border: 1px solid #e6e6e7;
  border-radius: 20px;
  padding: 50px 40px;
  min-height: 210px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  cursor: pointer;
  transition: all 250ms ease-in-out;
  i {
    position: relative;
    display: block;
    width: 130px;
    height: 90px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  p {
    font-weight: 700;
    font-size: 20px;
    line-height: 34px;
    color: #17479e;
    margin-top: 18px;
  }
  &:hover {
    box-shadow: 0 0 10px 0 #8d8e91;
  }
`;

export const GuidBox = styled.div`
  padding: 20px;
  background: url(${props => props.bg}) no-repeat center center / cover;
  border-radius: 15px;
  margin-bottom: 15px;
  p {
    font-weight: 500;
    font-size: 22px;
    line-height: 34px;
    color: #ffffff;
  }
`;

export const SideBox = styled.div`
  padding: 58px 48px;
  background: url(${props => props.bg}) no-repeat center center / cover;
  border-radius: 15px;
  margin-top: 15px;
  text-align: center;
  p {
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 34px;
    color: #ffffff;
  }
`;
